import { EntraJobsState } from './types';
import entraJobsSearchData  from '../../../model/smallPayloadModels/entrajobsSearchData';

export const state = (): EntraJobsState => initialState();

export const initialState = (): EntraJobsState => ({
  updatingUsersData: null,
  updatingUsers: false,
  entraJobsSearchData: entraJobsSearchData.defaultData(),
   entraJobDetailLog: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['timestamp'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
      andClauseFieldsIds: [],
    },
  },
});
